import { Default_getInstance1yflkybdrpcz6 as Default_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function freeze(_this__u8e3s4) {
  return _this__u8e3s4;
}
function getRandomUuidBytes() {
  return Default_getInstance().jo(16);
}
//region block: exports
export {
  freeze as freeze2t025y794sude,
  getRandomUuidBytes as getRandomUuidBytes3aykfxcg1y7rs,
};
//endregion

//# sourceMappingURL=platform.mjs.map
